export default __webpack_public_path__ + "static/thumb-accessories-5889e79853e2aae42168e4f8c58ecf80.png";